import React, { useState, Component, useRef } from 'react';
import { Form, Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import authService from '../api-authorization/AuthorizeService'
import debounce from 'lodash.debounce';


export class BLsView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            vaporSemanal: {},
            calibres: [],
            cajasPorPaleta: [],
            paises: [],
        };
        var rawUrl = window.location.toString();
        var vaporSemanal_Id = rawUrl.split("VaporesSemanales/")[1].split("/")[0];
        if (props.data) {
            this.state.model = props.data
        }
        else {
            this.state.model = { nombre: "", vaporSemanalProveedor_Id: vaporSemanal_Id, carga: "" };
        }
        this.state.modelValidation = {
            nombre: this.state.model.nombre != ""
        }
        this.load_vaporSemanal = this.load_vaporSemanal.bind(this);
       
        this.handleChange = this.handleChange.bind(this);
        this.validate = this.validate.bind(this);
        this.validate = debounce(this.validate, 1000)
    }
    componentDidMount() {
        this.populateData();
    }
    
    handleChange(event) {

        var tempModel = this.state.model;
        tempModel[event.target.name] = event.target.value;
        this.setState({
            model: tempModel
        }, () => {
            this.props.setModalBodyState(this.state).then(() => this.validate());
        });

    }
    async validate() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.state.model);
        const response = await fetch('api/bls/validate', {
            method: 'POST',
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            var validations = await response.json();
            this.setState({
                modelValidation: validations
            }, () => {
                this.props.setModalBodyState(this.state);
            });
        }
    }
    getValidationValue(value) {
        if (value == null || value == undefined) {
            return true;
        }
        else {
            return value;
        }
    }

    render() {
        return (
            <div >
                <Row>
                    <Form>
                        <FormGroup>
                            <Label for="nombre">
                                <FormattedMessage id='Nombre' />
                            </Label>
                            <Input
                                id="nombre"
                                name="nombre"
                                type="text"
                                onChange={this.handleChange}
                                value={this.state.model.nombre}
                                valid={this.getValidationValue(this.state.modelValidation.nombre)}
                                invalid={!this.getValidationValue(this.state.modelValidation.nombre)}
                            />
                            <FormFeedback>
                                {this.state.model.nombre == "" ? <FormattedMessage id='Este campo es requerido' /> : ""}
                            </FormFeedback>
                        </FormGroup>
                        <FormGroup>
                            <Label for="carga">
                                <FormattedMessage id='Carga' />
                            </Label>
                            <Input
                                id="carga"
                                name="carga"
                                type="select"
                                onChange={this.handleChange}
                                value={this.state.model.carga}
                            >
                                <option value=""></option>
                                <option value="Bodega">Bodega</option>
                                <option value="Cubierta">Cubierta</option>
                                
                            </Input>
                        </FormGroup>
                    </Form>
                </Row>
            </div>
        );
    }
    async populateData() {
        this.setState({ loading: true, vaporSemanal: await this.load_vaporSemanal() }, async () => {
            this.setState({ loading: false },
                async () => {
                }
            );
        });
        

    }
    async load_vaporSemanal() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/vaporesSemanalesProveedor/' + this.state.model.vaporSemanalProveedor_Id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    
}